import React from 'react';
import { useCutoffInfo } from '../../hooks/useCutoffInfo';

const fmt = (s, forceHours = false) => {
  s = Math.max(0, Math.floor(s));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n) => String(n).padStart(2, '0');
  if (h > 0 || forceHours) return `${pad(h)}:${pad(m)}:${pad(sec)}`;
  return `${pad(m)}:${pad(sec)}`;
};

// mini  → tiny inline chip "Next Cutoff: 00:00"
// compact → short card
// (default) → full card with progress bar + cutoff index
const CutoffTimer = ({ mini = false, compact = false }) => {
  const { info, secondsToNext, pct, currentCutoffIndex } = useCutoffInfo();
  if (!info) return null;

  if (mini) {
    return (
      <div className="cutoff-mini" title={`Cutoff #${currentCutoffIndex + 1}`}>
        <span className="cm-dot" />
        <span className="cm-label">Next Cutoff:</span>
        <span className="cm-value">{fmt(secondsToNext)}</span>
      </div>
    );
  }

  return (
    <div className={'cutoff-timer' + (compact ? ' compact' : '')}>
      <div className="ct-head">
        <div className="ct-label">
          <span className="ct-dot" />
          Next Farming Cutoff
        </div>
        <div className="ct-index">Cutoff #{currentCutoffIndex + 1}</div>
      </div>
      <div className="ct-value">{fmt(secondsToNext)}</div>
      <div className="ct-bar">
        <div className="ct-bar-fill" style={{ width: pct.toFixed(2) + '%' }} />
      </div>
      <div className="ct-foot">
        <span>Cutoff period elapsed {pct.toFixed(1)}%</span>
      </div>
    </div>
  );
};

export default CutoffTimer;
